import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { ASSOCIATED_INVESTORS_TABLE_COLUMNS } from 'constants/associated-investors';
import useFilterParameters from 'hooks/use-filter-parameters/useFilterParameters';
import { usePaginationWithSearch } from 'hooks/use-pagination-with-search/usePaginationWithSearch';
import useTableSorting from 'hooks/use-table-sorting/useTableSorting';
import { selectIsAdmin } from 'modules/current-user/selectors';
import { getFundsAssociatedInvestors } from 'modules/funds/action';
import { selectFundsAssociatedInvestors } from 'modules/funds/selectors';
import { useAppDispatch, useAppSelector } from 'modules/store';
import { Pagination } from 'shared-components';
import Table, { TableSkeleton } from 'shared-components/table';
import TableNoData from 'shared-components/table/TableNoData';

import AssociatedInvestorsTableRow from './AssociatedInvestorsTableRow';

const INVESTORS_PER_PAGE = 7;

const AssociatedInvesorsTable = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams();
  const { page, setPage, query } = usePaginationWithSearch();
  const { sorting, updateSorting } = useTableSorting();
  const { filter } = useFilterParameters();
  const isAdmin = useAppSelector(selectIsAdmin);

  const { associatedInvestors, isLoading: loading, totalPages, total } = useAppSelector(selectFundsAssociatedInvestors);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getFundsAssociatedInvestors({
        id: Number(id),
        page,
        per_page: INVESTORS_PER_PAGE,
        query,
        order: sorting.order,
        sort: sorting.column,
        filter,
        isAdmin: isAdmin,
      }),
    )
      .unwrap()
      .finally(() => setIsLoading(false));
  }, [dispatch, id, page, query, sorting.order, sorting.column, filter, isAdmin]);

  if (associatedInvestors.length < 1 && !isLoading) return <TableNoData text='No associated investors' />;

  return (
    <div className='flex flex-col'>
      <Table onUpdateSorting={updateSorting} columns={ASSOCIATED_INVESTORS_TABLE_COLUMNS}>
        {isLoading ? (
          <TableSkeleton rowsNumber={INVESTORS_PER_PAGE} columnsNumber={ASSOCIATED_INVESTORS_TABLE_COLUMNS.length} />
        ) : (
          associatedInvestors &&
          associatedInvestors.map((investor) => (
            <AssociatedInvestorsTableRow key={investor.investorName} investor={investor} />
          ))
        )}
      </Table>

      <Pagination currentPage={page} updatePage={setPage} loading={loading} totalPages={totalPages} total={total} />
    </div>
  );
};

export default AssociatedInvesorsTable;
